<template>

  <div class="location">


    <div class="deviceList" :class="hasCollapse ? 'collapseList' : ''">
      <!--      <h4 v-if="!this.showGroup" class="title">
              <el-row>
                <el-col class="totalText" :span="6">{{totalDev}}</el-col>
              </el-row>
            </h4>-->




      <div class="lifeguardList">
        <el-table ref="tabRef" :data="lifeguardList" class="lifeguardTable" @selection-change="handleSelectLifeguard">
          <el-table-column type="selection" align="center" display="none" />
          <el-table-column prop="userName" label="搜救员" align="center"></el-table-column>
        </el-table>
      </div>
      <!-- TODO 搜索设备 @change="searchHandle" -->
      <div class="searchInput">
        <el-input class="searchImei" :placeholder="$t('welcome.page.left.searchPlaceholder')"
          suffix-icon="el-icon-search" v-model="searchDeviceImei">
        </el-input>
      </div>
      <div class="searchInput tabWrap">
        <el-tabs class="allTree" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="totalDev" name="all">
            <!-- allMenuList  convertToTree()    -->
             <!-- filter-node-method  对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏 -->
            <el-tree ref="mTree"   :data="allMenuList" node-key="key" :accordion="false" :check-on-click-node="false"
              default-expand-all :show-checkbox="true" @check="selectNode" @node-click="clickNode"  :filter-node-method="mTreeFilterNode" >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-col :span="2">
                  <span class="itemClass">
                    <!-- <img class="treeIcon" :src="data.type === 1 ? dealerIcon : deviceIcon" alt="">
                    {{ getDeviceTitle(data) }} -->
                    <el-link type="primary" icon="el-icon-edit" class="el-dropdown-link operation" :underline="false"
                      v-if="data.type === 1 && pwdType === '2'" @click="toSoldDeviceManage(data)">{{
      $t('devicePage.option.edit') }}</el-link>
                    <!-- 下拉操作列表 一级菜单不显示操作 -->
                    <div v-if="extractNumber(data.label) != 0" >
                      <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link operation">
                          {{ $t('welcome.page.left.operation') }}
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="{ cmd: 'realTimeTracking', imei: extractNumber(data.label) }">{{ '跟踪'
                            }}</el-dropdown-item>
                          <el-dropdown-item :command="{ cmd: 'historicalTrack', imei: extractNumber(data.label) }">{{ '轨迹'
                            }}</el-dropdown-item>
                          <el-dropdown-item :command="{ cmd: 'modifyConfig', imei: extractNumber(data.label)}">{{
      $t('devicePage.sendCommand')
    }}</el-dropdown-item>
    <el-dropdown-item :command="{ cmd: 'transferDevice', imei: extractNumber(data.label) }">{{ '转移'}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </span>
                </el-col>
                <el-col :span="2">
                  <div v-if="data.deviceImei !== undefined" :class="getColor(data)"></div>
                </el-col>
                <el-col :span="10">
                  <span style="text-align: left; "> {{ node.label }}</span>
                </el-col>
              </span>
            </el-tree>
          </el-tab-pane>
          <el-tab-pane :label="onlineDev" name="available">
            <el-tree ref="mAvailableTree" :data="onlineMenuList" node-key="key" :accordion="false"
              :check-on-click-node="false" default-expand-all :show-checkbox="true" @check="selectNode" :filter-node-method="mAvailableTreeFilterNode"
              @node-click="clickNode">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-col :span="2">
                  <span class="itemClass">
                    <!-- <img class="treeIcon" :src="data.type === 1 ? dealerIcon : deviceIcon" alt="">
                    {{ getDeviceTitle(data) }} -->
                    <el-link type="primary" icon="el-icon-edit" class="el-dropdown-link operation" :underline="false"
                      v-if="data.type === 1 && pwdType === '2'" @click="toSoldDeviceManage(data)">{{
      $t('devicePage.option.edit') }}</el-link>
                    <!-- 下拉操作列表 -->
                    <div v-if="extractNumber(data.label) != 0" >
                      <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link operation">
                          {{ $t('welcome.page.left.operation') }}
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="{ cmd: 'realTimeTracking', imei: extractNumber(data.label) }">{{ '跟踪'
                            }}</el-dropdown-item>
                          <el-dropdown-item :command="{ cmd: 'historicalTrack', imei: extractNumber(data.label) }">{{ '轨迹'
                            }}</el-dropdown-item>
                          <el-dropdown-item :command="{ cmd: 'modifyConfig', imei: extractNumber(data.label) }">{{
      $t('devicePage.sendCommand')
    }}</el-dropdown-item>
    <el-dropdown-item :command="{ cmd: 'transferDevice', imei: extractNumber(data.label) }">{{ '转移'}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </span>
                </el-col>
                <el-col :span="2">
                  <div v-if="data.deviceImei !== undefined" :class="getColor(data)"></div>
                </el-col>
                <el-col :span="10">
                  <span style="text-align: left; "> {{ node.label }}</span>
                </el-col>
              </span>
            </el-tree>
          </el-tab-pane>
          <el-tab-pane :label="offlineDev" name="lost">
            <el-tree ref="mLostTree" :data="offlineMenuList" node-key="key" :accordion="false"
              :check-on-click-node="false" default-expand-all :show-checkbox="true" @check="selectNode"  :filter-node-method="mLostTreefilterNode"
              @node-click="clickNode">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-col :span="2">
                  <span class="itemClass">
                    <!-- <img class="treeIcon" :src="data.type === 1 ? dealerIcon : deviceIcon" alt="">    {{ getDeviceTitle(data)}} -->
                    <!-- {{JSON.stringify(data, null, 2) }}  -->
                   <!-- 编辑 -->
                    <el-link type="primary" icon="el-icon-edit" class="el-dropdown-link operation" :underline="false"
                    v-if="data.type === 1 && pwdType === '2'" @click="toSoldDeviceManage(data)">{{
      $t('devicePage.option.edit') }}</el-link>
                    <!-- 下拉操作列表 -->
                    <div v-if="extractNumber(data.label) != 0" >
                      <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link operation">
                          {{ $t('welcome.page.left.operation') }}
                        </span>
                        <el-dropdown-menu slot="dropdown" >
                          <el-dropdown-item :command="{ cmd: 'realTimeTracking', imei: extractNumber(data.label) }">{{ '跟踪'
                            }}</el-dropdown-item>
                          <el-dropdown-item :command="{ cmd: 'historicalTrack', imei: extractNumber(data.label) }">{{ '轨迹'
                            }}</el-dropdown-item>
                          <el-dropdown-item :command="{ cmd: 'modifyConfig', imei: extractNumber(data.label) }">{{
      $t('devicePage.sendCommand')
    }}</el-dropdown-item>

<el-dropdown-item :command="{ cmd: 'transferDevice', imei: extractNumber(data.label) }">{{ '转移'}}</el-dropdown-item>

                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </span>
                </el-col>
                <el-col :span="2">
                  <div v-if="data.deviceImei !== undefined" :class="getColor(data)"></div>
                </el-col>
                <el-col :span="10">
                  <span style="text-align: left; "> {{ node.label }}</span>
                </el-col>
              </span>
            </el-tree>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="collapseImg" @click="collapse" :class="hasCollapse ? 'collapseList' : ''">
      <i v-if="!hasCollapse" class="el-icon-arrow-left"></i>
      <i v-else class="el-icon-arrow-right"></i>
    </div>
    <div class="mapContainer" :class="hasCollapse ? 'collapseList' : ''">
      <GmapMap ref="mapRef" v-if="currentMap === 'google'" map-type-id="terrain" :center="{ lat: 10, lng: 10 }" :zoom="15"
        style="width: 100%; height: 100%" :options="{
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUI: false
    }">
      </GmapMap>
      <baidu-map v-if="currentMap === 'baidu'" class="baidu-map" :center="center" :zoom="15" @ready="handleBaidu"
        :scroll-wheel-zoom='true'>
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
        <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT" />
      </baidu-map>
    </div>
    <div class="deviceInfoList" v-if="showDeviceInfoList" draggable="true" @dragend="deviceInfoListDragEnd($event)"
      @dragstart="deviceInfoListDragStart($event)"
      :style="{ position: 'absolute', right: elRight + 'px', bottom: elBottom + 'px' }">
      <span class="closeDeviceInfoListButton" type="text" @click="hideDeviceInfoList">-</span>
      <el-table :highlight-current-row="true" :data="deviceAlarmList" style="width: 100%;" max-height="200px"
        class="alarmTable" @current-change="handleCurrentChange">
        <el-table-column prop="alarmId" v-if="false"></el-table-column>
        <el-table-column prop="deviceId" v-if="false"></el-table-column>
        <el-table-column prop="alarmTime" :label="$t('device.lastLocationTime')" width="160px;">
          <template slot-scope="scope">
            {{ convertDateTimeToString(scope.row.alarmTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceImei" :label="$t('device.deviceImei')" width="120px;"></el-table-column>
        <el-table-column prop="longitude" :label="$t('device.lastLongitude')" width="130px;"></el-table-column>
        <el-table-column prop="latitude" :label="$t('device.lastLatitude')" width="130px;"></el-table-column>
        <!--        <el-table-column prop="speed" label="速度" width="80px;"></el-table-column>-->
        <el-table-column prop="alarmType" :label="$t('device.alarm')" width="100px;"
          :formatter="alarmTypeFormatter"></el-table-column>
        <el-table-column label="操作" width="78px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" circle
              @click="setAlarmReadFun(scope.row.alarmId)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="listInfoTipBtn" v-else @click="hideDeviceInfoList">{{ $t('welcome.page.left.detailList') }}</div>
    <div class="timeClass">{{ $t('welcome.page.main.refreshPre') + second + $t('welcome.page.main.refreshNext') }}</div>
    <el-dialog :title="$t('welcome.page.sendCommand.title')" :visible.sync="commandDialogVisible" width="70%"
      @close="commandDialogClosed">
      <el-form :model="commandForm" ref="commandForm" :inline="true" :rules="commandFormRules" label-width="140px"
        label-position="right" class="commandFormClass">
        <el-row>
          <el-col :span="2">
            <el-button type="danger" @click="sendCommand(2)">{{ $t('welcome.page.sendCommand.stop') }}</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="sendCommand(3)">{{ $t('welcome.page.sendCommand.resume') }}</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="warning" @click="sendCommand(4)">{{ $t('welcome.page.sendCommand.openDoor') }}</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="success" @click="sendCommand(5)">{{ $t('welcome.page.sendCommand.closeDoor') }}</el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="success" @click="sendCommand(1)">{{ $t('welcome.page.sendCommand.start') }}</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="danger" @click="sendCommand(6)">{{ $t('welcome.page.sendCommand.stopAfter') }}</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="sendCommand(7)">{{ $t('welcome.page.sendCommand.photograph') }}
            </el-button>
          </el-col>
        </el-row>
        <br />
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('welcome.page.sendCommand.timeInterval')" label-width="160px">
              <el-input v-model="commandForm.setTimeInterval"
                :placeholder="$t('welcome.page.sendCommand.timeIntervalPlaceholder')"></el-input>
              <el-button class="sendBtn" @click="setTimeIntervalForTrackingFunc"></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('welcome.page.sendCommand.timeZone')" label-width="130px">
              <el-input class="wideInput" v-model="commandForm.timeZoneValue"
                :placeholder="$t('welcome.page.sendCommand.timeZonePlaceholder')"></el-input>
              <el-button class="sendBtn" @click="setTimeZoneFunc"></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('welcome.page.sendCommand.setAngle')" label-width="160px">
              <el-input v-model="commandForm.angle"
                :placeholder="$t('welcome.page.sendCommand.setAnglePlaceholder')"></el-input>
              <el-button class="sendBtn" @click="setAngleForTrackingFunc"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('welcome.page.sendCommand.setDistance')" label-width="160px">
              <el-input v-model="commandForm.distance"
                :placeholder="$t('welcome.page.sendCommand.setDistancePlaceholder')"></el-input>
              <el-button class="sendBtn" @click="setOdometerIntervalFunc"></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('welcome.page.sendCommand.setWiretapping')" label-width="130px">
              <el-input class="wideInput" v-model="commandForm.phoneNumber"
                :placeholder="$t('welcome.page.sendCommand.setWiretappingPlaceholder')"></el-input>
              <el-button class="sendBtn" @click="setTelePhoneForWiretappingFunc"></el-button>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item :label="$t('welcome.page.sendCommand.setSpeed')" label-width="160px">
              <el-select v-model="commandForm.speed" size="small"
                :placeholder="$t('welcome.page.sendCommand.setSpeedPlaceholder')">
                <el-option v-for="dic in speedLimitDic" :key="dic.codeValue" :value="dic.codeValue"
                  :label="dic.codeName">
                  {{ dic.codeName }}
                </el-option>
              </el-select>
              <el-button class="sendBtn" @click="setSpeedLimitFunc"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('welcome.page.sendCommand.movementAlert')" label-width="160px">
              <el-select v-model="commandForm.meters" size="small"
                :placeholder="$t('welcome.page.sendCommand.movementAlertPlaceholder')">
                <el-option v-for="dic in movementAlertDic" :key="dic.codeValue" :value="dic.codeValue"
                  :label="dic.codeName"> {{ dic.codeName }}
                </el-option>
              </el-select>
              <el-button class="sendBtn" @click="setMovementAlertFunc"></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item :label="$t('welcome.page.sendCommand.authorizedPhone')" label-width="130px">
              <el-select v-model="commandForm.buttonNumber" size="small"
                :placeholder="$t('welcome.page.sendCommand.authorizedPhonePlaceholder')">
                <el-option v-for="dic in authorizedPhoneTypeDic" :key="dic.codeValue" :value="dic.codeValue"
                  :label="dic.codeName"> {{ dic.codeName }}
                </el-option>
              </el-select>
              <el-input class="wideInput" v-model="commandForm.phoneNumberForReceiveSms"
                :placeholder="$t('welcome.page.sendCommand.phoneSMSPlaceholder')"></el-input>
              <el-input class="wideInput" v-model="commandForm.phoneNumberForReceiveCall"
                :placeholder="$t('welcome.page.sendCommand.phoneCALLPlaceholder')"></el-input>
              <el-button class="sendBtn" @click="setAuthorizedPhoneNumberFunc"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="$t('welcome.page.sendCommand.setRFID')" label-width="160px">
            <el-input v-model="commandForm.setRfid1" placeholder="RFID 1"></el-input>
            <el-input v-model="commandForm.setRfid2" placeholder="RFID 2"></el-input>
            <el-input v-model="commandForm.setRfid3" placeholder="RFID 3"></el-input>
            <el-input v-model="commandForm.setRfid4" placeholder="RFID 4"></el-input>
            <el-input v-model="commandForm.setRfid5" placeholder="RFID 5"></el-input>
            <el-button class="sendBtn"></el-button>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('welcome.page.sendCommand.sendMessage')" label-width="180px">
              <el-input class="sendMessage" type="textarea" v-model="commandForm.sendMessage"></el-input>
              <el-button class="sendBtn"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        </el-card>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="commandDialogVisible = false">{{ $t('welcome.page.sendCommand.closeBtn') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('welcome.page.deviceInfo.title')" :visible.sync="infoDialogVisible" width="50%"
      @close="infoDialogClosed">
      <el-form width="60%" :model="infoForm" :inline="true" ref="infoForm" max-height="100" label-position="left"
        class="infoFormClass">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('device.deviceImei') + ':'">
              <span>{{ infoForm.deviceImei }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'ICCID:'">{{ infoForm.iccid || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('device.onlineStatus') + ':'">{{ infoForm.onlineStatus ? 'online' : 'offline' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('device.deviceType') + ':'">{{ getSpecifiedDeviceType(infoForm.deviceType) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('device.createTime') + ':'">{{ infoForm.createTime }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('device.version') + ':'">{{ infoForm.version }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('device.lastDeviceVol') + ':'">{{ infoForm.lastDeviceVol || 0 }}&#37;
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('device.lastLocationTime') + ':'">{{ infoForm.lastLocationTime }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('device.lastLongitude') + ':'">{{ infoForm.lastLongitude }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('device.lastLatitude') + ':'">{{ infoForm.lastLatitude }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('device.lastSpeed') + ':'">{{ infoForm.lastSpeed }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('device.lastLocationType') + ':'">
              {{ getSpecifiedLocationType(infoForm.lastLocationType) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('device.altitude') + ':'">{{ infoForm.altitude }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('device.deviceRemark') + ':'">{{ infoForm.deviceRemark }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!--      <span slot="footer" class="dialog-footer">
            <el-button @click="infoDialogVisible = false">Close</el-button>
          </span>-->
    <el-dialog :visible.sync="showConfigDialog" :title="currentDeviceImei" width="20%">
      <el-form class="sendCmdForm">
        <el-form-item class="sendCmdItem">
          <el-col :span="8">
            <el-button type="warning" size="mini" @click="sendCommand(1)">
              立即定位
            </el-button>
          </el-col>
          <el-col :span="8">
            <el-button type="danger" size="mini" @click="sendCommand(3)">
              设防
            </el-button>
          </el-col>
          <el-col :span="8">
            <el-button type="success" size="mini" @click="sendCommand(4)">
              解除设防
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item class="sendCmdItem">
          <el-col :span="8">
            <el-button type="success" size="mini" @click="sendCommand(2)">
              解除警报
            </el-button>
          </el-col>
          <el-col :span="16">
            <el-button type="warning" size="mini" @click="sendCommand(5)">
              文本透传
            </el-button>
            <el-input v-model.trim="commandContent" placeholder="请输入透传内容" size="mini" clearable>
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfigDialog = false"> 关闭 </el-button>
      </span>
    </el-dialog>
    <audio ref="sosAudio" controls @ended="playEnd">
      <source src="../assets/audio/sos.mp3" type="audio/mp3">
    </audio>
    <el-dialog :visible.sync="rescueFormShow" class="rescueDialog" title="SOS告警" width="20%"
      @close="handleRescueFormClose">
      <el-form class="rescueForm">
        <el-form-item label="设备IMEI" class="rescueItem">{{ rescueForm.deviceImei }}</el-form-item>
        <el-form-item label="警报时间" class="rescueItem">{{ rescueForm.createTime }}</el-form-item>
        <el-form-item label="救援状态" class="rescueItem">{{ getRescueStatus(rescueForm.rescueStatus) }}</el-form-item>
        <el-form-item label="最新经度" class="rescueItem">{{ rescueForm.lastLongitude }}</el-form-item>
        <el-form-item label="最新纬度" class="rescueItem">{{ rescueForm.lastLatitude }}</el-form-item>
        <el-form-item label="最新定位时间" class="rescueItem">{{ rescueForm.lastLocationTime }}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="8">
            <el-button type="success" @click="deviceTrace()"> 跟踪 </el-button>
          </el-col>
          <el-col :span="8">
            <el-button type="success" @click="luanchResue()" :disabled="rescueForm.rescueStatus === 1"> 组织救援
            </el-button>
          </el-col>
          <el-col :span="8">
            <el-button type="success" @click="rescueFormShow = false"> 关闭 </el-button>
          </el-col>
        </el-row>

      </span>
    </el-dialog>


      <!-- 转移设备的对话框  这里只是弹出个窗口 其它功能没有实现-->
      <el-dialog title="转移设备" :visible.sync="addDialogVisible" width="40%" @close="transferDeviceDialogClosed">
      <!-- 内容主体 -->

      <el-form
      :model="transferDeviceForm"
      ref="transferDeviceFormRef"
      :rules="transferDeviceFormRules"
       label-width="150px"
        label-position="left"
      >
      <el-form-item label="customerId" v-if="false">
          <el-input    v-model="transferDeviceForm.customerId" v-if="false"></el-input>
        </el-form-item>

        <el-form-item label="设备号" >
          <!-- disabled  maxlength="30" -->
          <el-input v-model.trim="deviceIMIE" disabled></el-input>
        </el-form-item>

        <el-form-item label="上级客户" prop="customerName">
          <el-select

          v-model.trim="transferDeviceForm.customerId"  
                  placeholder="请选择上级客户"
           
            size="small"
            @focus="getSelectedCustomerList"
          >
            <el-option v-for="customer in selectedCustomerList"
                       :key="customer.customerId"
                       :value="customer.customerId"
                       :label="customer.customerName" >
              {{ customer.customerName }} </el-option>
          </el-select>
        </el-form-item>


      </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="sumTransferDevice">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>

import moment from 'moment'
import {
  getTransferDevice,
  getGpsDeviceByImei,
  lastDevicePosition,
  getDeviceConfiguration,
  updateDeviceConfiguration,
  getMultipleDeviceTraceLog, getAllDeviceByCustomer
} from '@/api/gpsDevice'
import { checkLogin, isNotLogin } from '@/api/globalProcessErr'
import { listAllGpsUser } from '@/api/gpsUser'
import { listCodeByClass } from '@/api/code'
import { listLifeguard } from '@/api/sysUser'
import {
  sendRemoteControl,
  setAuthorizedPhoneNumber,
  setTimeIntervalForTracking,
  setTimeZone,
  setAngleForTracking,
  setOdometerInterval,
  setTelePhoneForWiretapping,
  setSpeedLimit,
  setMovementAlert
} from '@/api/gpsDeviceCommand'
import { getDeviceHistoryTrajectoryLog } from '@/api/gpsDeviceTraceLog'
import {
  batchMakeMarker,
  initMap,
  openInfoWindowByDeviceImei,
  closeCurrentInfoWindow,
  makeTrackMarker,
  makePath,
  makeColorPath,
  convertTrackToDevice,
  changeMarkerPositionAndUpdateInfoWindow,
  moveToCenter, cleanAllPath, cleanCurrentPath, centerAndZoom, cleanMarks, cleanMapMarks
  // , moveToCenter
} from '@/api/map'
import { deviceStatusFormat, getObjString, convertDateTimeToString, objIsNull, searchFromList } from '@/api/util'
import { getDeviceTypeStr, getLocationTypeStr } from '../api/enum'
import { getFenceByLifeguard } from "@/api/polygonalFence";
import { listUnReadDeviceAlarm, setAlarmRead } from "@/api/deviceAlarm";
import router from "@/router";
import { launchRescue, listIncompleteRescue } from "@/api/rescue";

import { listOptionalCustomer } from '@/api/customer';  //  客户列表

/*import {objectToString} from "javascript-stringify/dist/object";*/

const REQUEST_ROWS = 10000


export default {
  name: 'locationMonitoring',
  data() {
    return {
      dealerIcon: require('@/assets/dealer.png'),
      deviceIcon: require('@/assets/device.png'),
      commandDialogVisible: false,
      commandForm: {
        deviceImei: '',
        commandBtn: undefined,
        setTimeInterval: undefined,
        timeZoneValue: undefined,
        angle: undefined,
        distance: undefined,
        phoneNumber: '',
        speed: undefined,
        meters: undefined,
        buttonNumber: undefined,
        phoneNumberForReceiveSms: '',
        phoneNumberForReceiveCall: ''
      },
      funValue: '',
      infoForm: {
        deviceImei: '',
        deviceName: '',
        deviceType: undefined,
        bindMobile: '',
        version: '',
        deviceShortNumber: '',
        deviceFamilyNumber: '',
        deviceRemark: '',
        lastLongitude: undefined,
        lastLatitude: undefined,
        lastLocationTime: undefined,
        lastLocationType: undefined,
        lastSpeed: undefined,
        lastMotionStatus: undefined,
        lastDeviceVol: '',
        lastDeviceSms: '',
        heading: undefined,
        odometer: undefined,
        onlineStatus: undefined
      },
      infoDialogVisible: false,
      timerInterval: 30, // 改了 30
      second: 30,
      userInterval: 10,
      showGroup: false,
      currentFence: undefined,
      createPoly: false,
      searchDeviceImei: '',
      commandContent: '',
      activeName: 'all',
      selectedUser: undefined,
      lifeguardList: [],
      gpsDeviceByOrgList: [],
      allMenuList: [],
      onlineMenuList: [],
      offlineMenuList: [],
      allMenuActiveName: '',
      onlineMenuActiveName: '',
      offlineMenuActiveName: '',
      allMenuSelectedDeviceImei: '',
      onlineMenuSelectedDeviceImei: '',
      offlineMenuSelectedDeviceImei: '',
      mCheckedKeys: [],
      deviceList: [],
      displayedDeviceList: [],
      manualLocationDeviceImei: '',
      gpsUserList: [],
      showUserList: false,
      showDeviceInfoList: false,
      hasCollapse: false,
      mapInstance: undefined,
      center: {
        lat: 22.5711440000,
        lng: 113.8687300000
      },
      centerSet: false,
      devicePoints: [],
      deviceMarks: [],
      infoWindowList: [],
      openedDevice: undefined,
      currentDeviceImei: '',
      movementAlertDic: [],
      authorizedPhoneTypeDic: [],
      speedLimitDic: [],
      intervalId: undefined,
      currentMap: 'baidu',
      selectedDevice: [],
      toBeRemove: [],
      toBeAdd: [],
      selectedDevices: [],
      initWidth: 0, // 父元素的宽-自适应值
      initHeight: 0, // 父元素的高-自适应值
      startClientX: 0, // 元素拖拽前距离浏览器的X轴位置
      startClientY: 0, // 元素拖拽前距离浏览器的Y轴位置
      elRight: 0, // 元素的左偏移量
      elBottom: 0, // 元素的右偏移量
      trackMap: new Map(),
      showConfigDialog: false,
      configurationData: {
        standbyDatetime: undefined,
        cst: undefined,
        rsut: undefined,
        rgli: undefined,
        rdui: undefined,
        lpl: undefined,
        lpgli: undefined,
        lpdui: undefined,
        nmst: undefined,
        nmet: undefined,
        ngli: undefined,
        ndui: undefined,
        cgli: undefined,
        cdui: undefined,
        rdut: undefined,
        gddt: undefined,
        rsud: undefined
      },
      pwdType: '',
      tabIndex: '0',
      // List<deviceImei>
      queryDeviceList: [],
      deviceMap: new Map(),
      // 结构： deviceImei: List<GpsTraceLogDto>
      trackListMap: new Map(),
      polylineMap: new Map(),
      audioPlaying: false,
      muted: true,
      audioPlayTimes: 0,
      deviceTrackMap: new Map(),
      colorMap: new Map(),
      deviceAlarmList: [],
      rescueList: [], // 救援列表,
      rescueForm: {},
      rescueFormShow: false,
      alarmTypeDic: [],
      mapOk: false,
      addDialogVisible:false, // 转移设备弹窗
     deviceIMIE: '',  // 转移设备号
     selectedCustomerList: [],  // 要展示的客户数据
     transferDeviceForm:{ 
      customerId: undefined,
        customerName: '',
     },
     transferDeviceFormRules: {
      customerName: [
          { required: true, message: this.$t('customerPage.rules.customerName.required'), trigger: 'blur' },
          {
            min: 4,
            max: 30,
            message: this.$t('customerPage.rules.customerName.length'),
            trigger: 'blur'
          }],
     },
    
    }
  },
  props: {
    commandFormRules: {}
  },
  computed: {

    getRescueStatus(data) {
      return function (data) {
        if (data === 0) {
          return '等待救援'
        }
        if (data === 1) {
          return '救援中'
        }
        if (data === 2) {
          return '已救援'
        }
        return ''
      }
    },
    getDeviceTitle(data) {
      // alert(this.extractNumber(data.label))
     
      return function (data) {
        let str = getObjString(data.title)
        str = str + ' '
        if (data.deviceOnline) {
          str = str + '在线 '
        } else {
          str = str + '离线 '
        }
        if (data.deviceVol) {
          str = str + getObjString(data.deviceVol)
          str = str + '%'
        }

        return str
      }
    },
    getStatus(data) {
      return function (data) {
        let statusText = ''
        if (data === undefined || data === null || data === '') {
          return ''
        }
        if (data.status === undefined || data.status === null) {
          return ''
        }
        if (data.status.engineStatus === 1) {
          statusText = 'Acc On'
        } else if (data.status.engineStatus === 0) {
          statusText = 'Acc Off'
        }

        if (data.status.doorStatus === 1) {
          statusText = statusText === '' ? 'Door Open' : statusText + '|Door Open'
        }

        if (data.status.headlightStatus === 1) {
          statusText = statusText === '' ? 'Headlights on' : statusText + '|Headlights on'
        }

        if (data.status.airConditionStatus === 1) {
          statusText = statusText === '' ? 'Air conditioner on' : statusText + '|Air conditioner on'
        }

        return statusText
      }
    },
    getColor(data) {
      return function (data) {
        if (data === undefined || data === null || data === '') {
          return ''
        }
        if (data.statusText === undefined || data.statusText === null || data.statusText === '') {
          return ''
        }
        if (data.onlineStatus && data.lastMotionStatus === 1) {
          return 'statusRun'
        }
        if (data.onlineStatus) {
          return 'statusOnline'
        }
        return 'statusOffline'
      }
    },
    totalDev: function () {
      let total = 0
      if (this.deviceList) {
        total = this.deviceList.length
      }
      return '全部(' + total + ')'
    },
    offlineDev: function () { // 全部 - 在线 = 离线
      let offline = 0
      // if (this.deviceList) {
      //   for (let i = 0; i < this.deviceList.length; i++) {
      //     if (this.deviceList[i].onlineStatus) {
      //       break
      //     }
      //     offline++
      //   }
      // }
      let total = 0
      if (this.deviceList) {
        total = this.deviceList.length
      }

      let online = 0
      if (this.deviceList.length > 0) {
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceList[i].onlineStatus && (this.deviceList[i].lastMotionStatus === null || this.deviceList[i].lastMotionStatus === 0)) {
            online++
          }
        }
      }

      return '离线(' + (total-online) + ')'
    },
    onlineDev: function () {
      let online = 0
      if (this.deviceList.length > 0) {
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceList[i].onlineStatus && (this.deviceList[i].lastMotionStatus === null || this.deviceList[i].lastMotionStatus === 0)) {
            online++
          }
        }
      }
      return '在线(' + online + ')'
    },
    runDev: function () {
      let run = 0
      if (this.deviceList.length > 0) {
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceList[i].onlineStatus && this.deviceList[i].lastMotionStatus === 1) {
            run++
          }
        }
      }
      return this.$t('welcome.page.left.deviceRun') + run
    }
  },
  created() {
    const beforeUnload = function () {
      sessionStorage.removeItem('deviceImei')
      sessionStorage.removeItem('dealerId')
      sessionStorage.removeItem('dealerName')
      sessionStorage.removeItem('historicalTrackDeviceImei')
      window.removeEventListener('beforeunload', beforeUnload)
    }
    window.addEventListener('beforeunload', beforeUnload)
    this.$i18n.locale = window.sessionStorage.getItem('lang')
    this.checkLang()
    

    // this.listAllUser()
  },
  beforeRouteLeave(to, from, next) {
    if (!this.muted) {
      this.$refs.sosAudio.pause()
    }
    clearInterval(this.intervalId)
    next()
  },
  // TODO 监控搜索框中的数据
  watch: {
    searchDeviceImei(val) {
        this.$refs.mTree.filter(val);
        this.$refs.mAvailableTree.filter(val);
        this.$refs.mLostTree.filter(val);
      }
  },
  mounted() {
    this.pwdType = window.sessionStorage.getItem('pwdType')
    let _this = this
    
    this.getLifeguardList()
   
    this.getAlarmTypeDic()
    window.realTimeTrack = function (deviceImei) {
      _this.realTimeTrack(deviceImei)
    }
    window.historicalTrack = function (deviceImei) {
      _this.historicalTrack(deviceImei)
    }
    window.sendCommand = function (deviceImei) {
      _this.openSendCommandDiag(deviceImei)
    }
    window.modifyConfiguration = function (deviceImei) {
      _this.modifyConfiguration(deviceImei)
    }
    // 转移设备
    window.transferDevice = function (deviceImei) {
      _this.transferDevice(deviceImei)
      
    }
    window.flightTraining = function (deviceImei) {
      _this.flightTraining(deviceImei)
    }
    window.getDeviceInfo = function (deviceImei) {
      _this.getDeviceInfo(deviceImei)
    }

    setTimeout(function () {
      _this.initMapPage()
    }, 800)

    /*_this.intervalId = setInterval(function () {
      _this.interval()
    }, 1000)*/
    _this.initWidth = document.documentElement.clientWidth
    _this.initHeight = document.documentElement.clientHeight
    _this.initAll()
   
   
  },
  methods: {
    // TODO 测试方法 false 隐藏 true 显示
    // 离线
    mLostTreefilterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      // 全部
      mTreeFilterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      // 在线
      mAvailableTreeFilterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },

    async transferDeviceDialogClosed(){  //   转移设备 关闭弹窗
       await this.listAllDealers()
    },
    convertToTree(data) {   // 转换数据为树形结构  
 // 假设 data 是一个包含多个顶级 customer 对象的数组  
  // 如果 data 不是一个数组，我们将其转换为一个数组  
  if (!Array.isArray(data)) {  
    data = [data];  
  }  
  
  // 定义一个递归函数来处理数据转换  
  function buildTreeNodes(items) {  
    return items.map(item => {  
      const { customerName, deviceList, childList } = item;  
  
      // 创建当前节点的对象  
      let currentNode = {  
        label: customerName,  
        children: []  
      };  
  
      // 处理 deviceList，将它们作为特殊的子节点添加（如果需要的话）     label: `设备ID: ${device.deviceId}, IMEI: ${device.deviceImei}, 电池电量: ${device.lastDeviceVol}`,  
      if (deviceList && deviceList.length > 0) {  
        currentNode.children.push(...deviceList.map(device => ({  
          label: `${device.deviceImei} ${device.onlineStatus == true?" 在线 ":" 离线 "} ${device.lastDeviceVol == null || device.lastDeviceVol == 0  ? " " : device.lastDeviceVol + "%"}`,  
         
          // 可以根据需要添加更多属性或字段  
          // 注意：这里我们直接将设备作为子节点，而不是将它们放在另一个层级  
        })));  
      }  
  
      // 递归处理 childList  
      if (childList && childList.length > 0) {  
        currentNode.children = currentNode.children.concat(buildTreeNodes(childList));  
      }  
  
      return currentNode;  
    });  
  }  
  
  // 调用递归函数处理数据  
  const treeData = buildTreeNodes(data);  
  
  // 返回树形数据  
  return treeData;  
} ,
extractNumber(formData) {   // 截取设备号
      // 使用正则表达式找到汉字前面的数字部分  
      const match = formData.match(/^(\d+)/);  
       return match ? match[1] : '0';  
    }  ,
    sumTransferDevice(){  // 转移设备 校验数据
      // 提交请求前，表单预验证
      const self = this
      const deviceImei = self.deviceIMIE
      const formData = self.transferDeviceForm
      // alert(deviceImei+"提交请求前:"+formData.customerId)
      if (formData.customerId !== undefined) {
        getTransferDevice(deviceImei,formData.customerId).then(res => {
          checkLogin(res)
          if (res.data.code !== 0) {
            return self.$message.error(res.data.msg)
          }
          self.$message.success(self.$t('common.updateSuccess'))
          // alert("发送成功:"+res.data)
          // this.getCustomerList()
        }).catch(err => {
          return self.$message.error(err.message)
        })
      }else{// 未选择客户
        alert("请选择客户")
      }
    },
    getSelectedCustomerList () {
      const _this = this
      listOptionalCustomer().then(res => {
        checkLogin(res)
        if (res.data.code !== 0) {
          return _this.$message.error(res.data.msg)
        }
        _this.selectedCustomerList = res.data.data
      }).catch(err => {
        return _this.$message.error(err.message)
      })
    },
    async wait(millisecond) {
      function f(millisecond) {
        return new Promise(resolve => setTimeout(resolve, millisecond));
      }

      await f(millisecond)
    },
  
    initAll() {
      this.asyncInit()
    },

    async asyncInit() {
      // 最多等待10秒
      const self = this
      for (let i = 0; i < 10; i++) {
        if (self.mapOk) {
          break
        }
        await self.wait(500)
      }
      
      await self.listAllDealers()
      await self.getAllUnReadAlarm()
      await self.listRescue()
      self.markAllDevice()
      self.intervalId = setInterval(function () {
        self.interval()
      }, 1000)
    },
    handleCommand(data) {
      switch (data.cmd) {
        case 'realTimeTracking':
          this.realTimeTrack(data.imei)
          break
        case 'historicalTrack':
          this.historicalTrack(data.imei)
          break
        case 'circularFence':
          this.openCircularFence(data.imei)
          break
        case 'polygonalFence':
          this.openPolygonalFence(data.imei)
          break
        case 'sendCommand':
          this.openSendCommandDiag(data.imei)
          break
        case 'flightTraining':
          this.flightTraining(data.imei)
          break
        case 'modifyConfig':
          this.modifyConfiguration(data.imei)
          break
        case 'transferDevice':    // 转移设备
          this.transferDevice(data.imei)

          break
      }
    },
    getMovementAlertDic() {
      listCodeByClass('MOVEMENT_ALERT').then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.movementAlertDic = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    getAuthorizedPhoneTypeDic() {
      listCodeByClass('AUTHORIZED_PHONE_BUTTON').then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.authorizedPhoneTypeDic = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    getSpeedLimitDic() {
      listCodeByClass('SPEED_ALERT').then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.speedLimitDic = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    checkLang() {
      this.$i18n.locale = 'zh-CN'
      if (this.$i18n.locale === 'zh-CN') {
        this.currentMap = 'baidu'
        this.center = {
          lat: 22.5711440000,
          lng: 113.8687300000
        }
      } else {
        this.currentMap = 'google'
        this.center = {
          lat: 25.037798,
          lng: 121.565170
        }
      }
    },
    handleBaidu({ BMap, map }) {
      this.mapInstance = {
        mapType: 'baidu',
        map: map,
        bMap: BMap,
        // map: window.$BAIDU$._instances.TANGRAM__1,
        // bMap: window.BMap,
        markList: [],
        polyList: [],
        currentOpenInfoWindow: undefined,
        contentFunc: this.makeInfoWindowContent,
        haveBtn: true
      }
      this.mapOk = true
    },
    initMapPage() {
      if (this.currentMap === 'google') {
        if (this.mapInstance === undefined) {
          this.mapInstance = {
            mapType: 'google',
            map: this.$refs.mapRef.$mapObject,
            mapRef: this.$refs.mapRef,
            googleMaps: window.google.maps,
            markList: [],
            polyList: [],
            currentOpenInfoWindow: undefined,
            contentFunc: this.makeInfoWindowContent,
            haveBtn: true
          }
        }
      } else {
        if (this.mapInstance === undefined) {
          this.mapInstance = {
            mapType: 'baidu',
            // map: map,
            // bMap: BMap,
            map: window.$BAIDU$._instances.TANGRAM__1,
            bMap: window.BMap,
            markList: [],
            polyList: [],
            currentOpenInfoWindow: undefined,
            contentFunc: this.makeInfoWindowContent,
            haveBtn: true
          }
        }
      }
      initMap(this.mapInstance, this.center, 15)
    },
    // 此函数获取需要展示标记的设备列表
    getDisplayedDevice() {
      if (this.deviceList && this.deviceList.length > 0) {
        let f = function (device, item) {
          if (device) {
            if (device.deviceImei === item.deviceImei) {
              return true
            }
          }
          return false
        }
        this.displayedDeviceList = []
        // 指示是否在循环中已经加入了搜索框中的imei
        let hasSearchedImei = false
        // 指示是否在循环中已经加入了下发手动定位的imei
        let hasManualLocationImei = false
        this.deviceList.forEach(item => {
          if (searchFromList(this.deviceList, item, f)) {
            if (item.deviceImei === this.searchDeviceImei) {
              hasSearchedImei = true
            }
            if (item.deviceImei === this.manualLocationDeviceImei) {
              hasManualLocationImei = true
            }
            // 警报列表中的图标为 endMarker
            item.iconType = 'end'
            this.displayedDeviceList.push(item)
          }
        })
        // 如果没有加入搜索框中输入的设备，则这里加入进去
        if (this.searchDeviceImei && (!hasSearchedImei)) {
          for (let i = 0; i < this.deviceList.length; i++) {
            if (this.searchDeviceImei === this.deviceList[i].deviceImei) {
              // 手工搜索出来的，又不是在警报列表中，图标为 startMarker
              this.deviceList[i].iconType = 'start'
              this.displayedDeviceList.push(this.deviceList[i])
              break
            }
          }
        }
        // 如果没有加入下发了收到请求立即定位的设备，则这里加入进去
        if (this.manualLocationDeviceImei && (!hasManualLocationImei)) {
          for (let i = 0; i < this.deviceList.length; i++) {
            if (this.manualLocationDeviceImei === this.deviceList[i].deviceImei) {
              // 下发了立即定位的，图标也是 startMarker
              this.deviceList[i].iconType = 'start'
              this.displayedDeviceList.push(this.deviceList[i])
              break
            }
          }
        }

        // 列入警报
        /*if(this.deviceAlarmList){
          for(let i=0;i<this.deviceAlarmList.length;i++){
            if (!searchFromList(this.displayedDeviceList,this.deviceAlarmList[i],f)){

            }
          }
        }*/

        return
      }
      this.displayedDeviceList = []
    },
    markAllDevice() {
      let self = this
      self.getDisplayedDevice()
      cleanMarks(self.mapInstance)
      if (self.displayedDeviceList && self.displayedDeviceList.length > 0) {
        self.displayedDeviceList.forEach(item => {
          makeTrackMarker(self.mapInstance, item, item.iconType)
        })
      }
    },
    makeInfoWindowContent(device, haveBtn) {
      const self = this
      return function () {
        let content = '<style>'
        content += '.deviceInfo { font-size: 12px; margin: 0; padding: 0;}'
        content += 'ul li { display: flex; flex-flow: row nowrap; justify-content: center; align-items: center; }'
        content += 'ul li div { width: 200px; }'
        content += '.centerDiv{ width: 100%; display: flex; justify-content: space-around; margin-top: 4px; }'
        content += '.centerDiv button { font-size: 12px; width: 120px; border-radius: 10px; color: white; }'
        content += '.buluButton { border: 1px solid #00A2E9; background-color: rgba(0, 162, 240 ,0.5); }'
        content += '.orangeButton { border: 1px solid chocolate; background-color: rgba(210, 105, 30, 0.5); } '
        content += '.redButton { border: 1px solid red; background-color: rgba(233, 10, 10, 0.5); }'
        content += '.purpleButton { border: 1px solid purple; background-color: rgba(128, 0, 128, 0.5); }'
        content += '.yellowButton { border: 1px solid #F0AC20; background-color: rgba(242, 120, 32, 0.5); }'
        content += '</style>'
        content += '<ul class="deviceInfo">'
        if (device.deviceType !== 2) {
          let item = 'engine'
          content += '<li> <div> <b>' + self.$t('device.deviceImei') + ':</b> <span>' + device.deviceImei + '</span> </div>'
          /*          content += '<div> <b>' + self.$t('device.deviceName') + ':</b> <span>' + device.deviceName + '</span> </div> </li>'*/
          content += '<div> <b>' + self.$t('device.lastLocationTime') + ':</b> <span>' + convertDateTimeToString(device.lastLocationTime) + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('device.lastLongitude') + ':</b> <span>' + getObjString(device.lastLongitude) + '</span> </div> '
          /* content += '<li> <div> <b>' + self.$t('device.accStatus') + ':</b> <span>' + deviceStatusFormat(device, item) + '</span> </div>'*/
          content += '<div> <b>' + self.$t('device.lastLatitude') + ':</b> <span>' + getObjString(device.lastLatitude) + '</span> </div> </li>'
          /*content += '<li> <div> <b>' + self.$t('device.lastSpeed') + ':</b> <span>' + getObjString(device.lastSpeed) + '</span> </div>'*/
          /* content += '<div> <b>' + self.$t('device.heading') + ':</b> <span>' + getObjString(device.heading) + '</span> </div> </li>'*/
          /*          content += '<li> <div> <b>' + self.$t('device.odometer') + ':</b> <span>' + getObjString(device.odometer) + '</span> </div>'*/
          /* content += '<div> <b>' + self.$t('device.fuel') + ':</b> <span>' + getObjString(device.fuel) + '</span> </div> </li>'*/
          content += '<li> <div> <b>' + self.$t('device.lastDeviceVol') + ':</b> <span>' + getObjString(device.lastDeviceVol) + '</span> </div> '
          content += '<div> <b>最新上报 :</b> <span>' + convertDateTimeToString(device.lastLocationTime) + '</span> </div> </li>'
        } else {
          let speed = 0
          if (device.odometer && device.duration && device.duration !== 0) {
            speed = device.odometer / device.duration
          }
          let averageSpeed = 0
          if (device.accumulateOdometer && device.accumulateDuration && device.accumulateDuration !== 0) {
            averageSpeed = device.accumulateOdometer / device.accumulateDuration
          }
          content += '<li> <div> <b>' + self.$t('device.deviceImei') + ':</b> <span>' + device.deviceImei + '</span> </div>'
          content += '<div> <b>' + self.$t('device.nickname') + ':</b> <span>' + device.deviceName + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('device.lastDeviceVol') + ':</b> <span>' + (device.deviceVol || 0) + '%' + '</span> </div>'
          content += '<div> <b>' + self.$t('device.version') + ':</b> <span>' + (device.version || '') + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('device.positioningTime') + ':</b> <span>' + convertDateTimeToString(device.gpsTime) + '</span> </div>'
          content += '<div> <b>' + self.$t('device.uploadTime') + ':</b> <span>' + convertDateTimeToString(device.logTime) + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('device.lastLatitude') + ':</b> <span>' + device.lat + '</span> </div>'
          content += '<div> <b>' + self.$t('device.lastLongitude') + ':</b> <span>' + device.lng + '</span> </div> </li>'
          // content += '<li> <div> <b>' + self.$t('device.weather') + ':</b> <span>' + device.weather + '</span> </div>'
          // content += '<div> <b>' + self.$t('device.lastPositionDesc') + ':</b> <span>' + device.lastPositionDesc + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('device.distanceFromPreviousPoint') + ':</b> <span>' + (device.odometer || 0) + self.$t('unit.meter') + '</span> </div>'
          content += '<div> <b>' + self.$t('device.timeFromPreviousPoint') + ':</b> <span>' + (device.duration || 0) + self.$t('unit.second') + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('unit.speedPerMinute') + ':</b> <span>' + (speed * 60).toFixed(4) + self.$t('unit.meterPerMinute') + '</span> </div>'
          content += '<div> <b>' + self.$t('unit.speedPerHour') + ':</b> <span>' + (speed * 3.6).toFixed(4) + self.$t('unit.kilometerPerHour') + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('unit.averageSpeedPerMinute') + ':</b> <span>' + (averageSpeed * 60).toFixed(4) + self.$t('unit.meterPerMinute') + '</span> </div>'
          content += '<div> <b>' + self.$t('unit.averageSpeedPerHour') + ':</b> <span>' + (averageSpeed * 3.6).toFixed(4) + self.$t('unit.kilometerPerHour') + '</span> </div> </li>'
          content += '<li> <div> <b>' + self.$t('device.altitude') + ':</b> <span>' + (device.altitude || 0) + self.$t('unit.meter') + '</span> </div>'
          content += '<div> <b>' + self.$t('device.locationPoints') + ':</b> <span>' + (device.pointIndex || '') + '</span> </div> </li>'
          haveBtn = false
        }
        if (haveBtn) {
          content += '<li> <div class="centerDiv">'
          content += '<button class="buluButton" onclick="realTimeTrack(\'' + device.deviceImei + '\')"" type="button"> ' + self.$t('devicePage.realTimeTrack') + ' </button>'
          content += '<button class="orangeButton" onclick="historicalTrack(\'' + device.deviceImei + '\')" type="button">  ' + self.$t('devicePage.historicalTrack') + '  </button>'
          /*          content += '<button class="redButton" onclick="flightTraining(\'' + device.deviceImei + '\')" type="button">  ' + self.$t('devicePage.flightTraining') + '  </button>'*/
          // content += '<button onclick="sendCommand(\'' + device.deviceImei + '\')" type="button">  ' + self.$t('devicePage.sendCommand') + '  </button>'
          content += '<button class="purpleButton" onclick="modifyConfiguration(\'' + device.deviceImei + '\')" type="button">  指令  </button>'
          /*  content += '<button class="yellowButton" onclick="getDeviceInfo(\'' + device.deviceImei + '\')" type="button">  ' + self.$t('devicePage.getDeviceInfo') + ' </button>'*/
          content += '</div> </li>'
        }
        content += '</ul>'
        return content
      }
    },
    handleSelectLifeguard(selection) {
      if (selection.length > 1) {
        selection.shift()
        this.$refs.tabRef.clearSelection()
        this.$refs.tabRef.toggleRowSelection(selection[0])
      }

      let userId = selection.map(item => item.userId)[0]
      if (userId === undefined || userId === null) {
        // 取消了
        cleanAllPath(this.mapInstance)
        return
      }
      let self = this
      getFenceByLifeguard(userId).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.currentFence = res.data.data
        self.drawPolygon()
        self.mapToCenter()
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    mapToCenter() {
      if (objIsNull(this.currentFence) || objIsNull(this.currentFence.fenceId)) {
        return
      }

      let points = this.currentFence.list
      centerAndZoom(this.mapInstance, points)
    },
    drawPolygon() {
      cleanAllPath(this.mapInstance)
      if (objIsNull(this.currentFence) || objIsNull(this.currentFence.fenceId)) {
        return
      }
      let pointList = []
      for (let j = 0; j < this.currentFence.list.length; j++) {
        let data = {
          lng: this.currentFence.list[j].longitude,
          lat: this.currentFence.list[j].latitude
        }
        pointList.push(data)
      }
      this.makeLine(pointList, false)
      this.createPoly = false
    },
    makeLine(pointList, isCreate) {
      if (pointList.length <= 2) return
      let points = []
      for (let j = 0; j < pointList.length; j++) {
        points.push(pointList[j])
      }
      points.push(points[0])
      if (isCreate) {
        if (this.createPoly) {
          cleanCurrentPath(this.mapInstance)
        }
      }
      makePath(this.mapInstance, points)
      if (isCreate) {
        this.createPoly = true
      }
    },
    // 点击跟踪按钮
    deviceTrace() {
      this.rescueFormShow = false
      let self = this
      return self.realTimeTrack(self.rescueForm.deviceImei)
    },
    luanchResue() {
      let self = this
      launchRescue(self.rescueForm.rescueId).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error('报错啦：' + res.data.msg)
        }
        return self.$message.success('执行成功！')
      }).catch(err => {
        return self.$message.error('报错啦：' + err)
      })
    },
    async interval() {
      const self = this
      self.second--
      if (self.second < 1) {
        // await self.listAllDealers()
        await self.getAllUnReadAlarm()
        await self.listRescue()
        self.markAllDevice()
        self.second = self.timerInterval
      }
    },
    getDevicePosition(imei) {
      if (!imei || imei.length === 0) {
        return
      }
      lastDevicePosition(imei).then(res => {
        if (res.data.code === 0 && res.data.data) {
          const data = res.data.data
          const lng = data.lastLongitude
          const lat = data.lastLatitude
          let trackList = []
          if (this.trackMap.has(imei)) {
            trackList = this.trackMap.get(imei).tracks
          }
          this.mapInstance.markList.forEach(item => {
            if (item.deviceImei === imei) {
              const point = item.marker.getPosition()
              if ((point.lat !== lat || point.lng !== lng) && (lat !== 0 || lng !== 0)) {
                // changeMarkerPositionAndUpdateInfoWindow(this.mapInstance, res.data.data)
                if (trackList.length > 0) {
                  this.getDeviceHistory(imei, trackList[trackList.length - 1].logId)
                } else {
                  this.getDeviceHistory(imei, 0)
                }
              }
              return null
            }
          })
        }
      })
    },
    getDeviceHistory(imei, logId) { // 获取设备的历史轨迹
      if (!imei || imei.length === 0) {
        return
      }
      const data = {
        deviceImei: imei,
        startTime: moment(new Date()).format('yyyy-MM-DD 00:00:00'),
        endTime: moment(new Date()).format('yyyy-MM-DD 23:59:59'),
        nextId: logId,
        requestRows: REQUEST_ROWS
      }
      getDeviceHistoryTrajectoryLog(data).then(res => {
        if (res.data.code === 0 && res.data.data && res.data.data.list && res.data.data.list.length > 0) {
          if (this.trackMap.has(imei)) { // 将trackLog对象存放到Map<imei, trackList>中
            const list = this.trackMap.get(imei).tracks
            res.data.data.list.forEach(item => {
              if (list.length === 0) {
                makeTrackMarker(this.mapInstance, item, 'start')
              } else {
                if (item.supplement === 1) {
                  makeTrackMarker(this.mapInstance, item, 'supplement')
                } else {
                  makeTrackMarker(this.mapInstance, item, 'subordinate')
                }
                if (list.length === res.data.data.list.length - 1) {
                  this.mapInstance.markList.forEach(element => {
                    if (element.deviceImei === imei && element.lastLatitude !== 0 && element.lastLongitude !== 0) {
                      changeMarkerPositionAndUpdateInfoWindow(this.mapInstance, convertTrackToDevice(item))
                      return null
                    }
                  })
                }
              }
              list.push(item)
            })
            makePath(this.mapInstance, list)
          }
          if (res.data.data.list.length === REQUEST_ROWS && res.data.data.list[REQUEST_ROWS - 1].logId) {
            this.getDeviceHistory(imei, res.data.data.list[REQUEST_ROWS - 1].logId)
          }
        }
      })
    },
    getDeviceByDeviceImei(deviceImei) {
      getGpsDeviceByImei(deviceImei).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.infoForm = res.data.data
      })
    },
    searchHandle() {
      if (!this.searchDeviceImei) {
        return
      }
      //
      let exist = false
      let device
      if (this.deviceList && this.deviceList.length > 0) {
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceList[i].deviceImei === this.searchDeviceImei) {
            exist = true
            device = this.deviceList[i]
            break
          }
        }
      }
      if (!exist) {
        this.$message.error("输入的设备IMEI不存在！")
        return
      }

      // 判定是否已经标记了，如果标记了,则移动地图，然后退出
      if (this.mapInstance.markList && this.mapInstance.markList.length > 0) {
        for (let i = 0; i < this.mapInstance.markList.length; i++) {
          if (this.mapInstance.markList[i].deviceImei === this.searchDeviceImei) {
            openInfoWindowByDeviceImei(this.mapInstance, this.searchDeviceImei)
            return
          }
        }
      }

      // makeTrackMarker(this.mapInstance, device, 'start')
      openInfoWindowByDeviceImei(this.mapInstance, this.searchDeviceImei)
    },
    clickNode(node, data, value) { //  TODO 点击节点在地图上展示设备位置 
      // alert(node.label);
      // alert(JSON.stringify(node, null, 2));
      // alert(JSON.stringify(data, null, 2));
      // alert(JSON.stringify(value, null, 2));
      let deviceImei = this.extractNumber(node.label)    // node.deviceImei

      if (deviceImei && deviceImei.length) {
        let markerList = this.mapInstance.markList
        if (markerList && markerList.length) {
          for (let i = 0; i < markerList.length; i++) {
            if (markerList[i].deviceImei === deviceImei) {
            
              moveToCenter(this.mapInstance, markerList[i].point)
            }
          }

    // 判定是否已经标记了，如果标记了,则移动地图，然后退出
    if (this.mapInstance.markList && this.mapInstance.markList.length > 0) {
            for (let i = 0; i < this.mapInstance.markList.length; i++) {
              if (this.mapInstance.markList[i].deviceImei === deviceImei) {
                openInfoWindowByDeviceImei(this.mapInstance, deviceImei)
                return
              }
            }
          }
          // device
      makeTrackMarker(this.mapInstance, device, 'start')
      openInfoWindowByDeviceImei(this.mapInstance, deviceImei)


          // if (this.mapInstance.currentOpenInfoWindow !== undefined && this.mapInstance.currentOpenInfoWindow !== null) {
          //   this.mapInstance.currentOpenInfoWindow.infoWindow.close()
          // }
          // marker.infoWindow.open()
        }
      }
      // if (data.data.title && data.childNodes.length === 0) {
      //   openInfoWindowByDeviceImei(this.mapInstance, data.data.title)
      // }
    },
    selectNode(data, node) { // 选择节点
      this.selectedDevices = []
      node.checkedNodes.forEach(item => {
        if (item.type === 2) {
          this.selectedDevices.push(item.deviceImei)
        }
      })
    },
    getToBeAdd(node) {
      this.toBeAdd = []
      if (node.checkedNodes.length === 0) {
        return
      }
      for (let k = 0; k < node.checkedNodes.length; k++) {
        if (node.checkedNodes[k].title !== undefined) {
          this.toBeAdd.push(node.checkedNodes[k].title)
        }
      }
    },
    getChildDevice(data) {
      if (data.title === undefined) {
        if (data.children.length === 0) {
          return
        }
        for (let i = 0; i < data.children.length; i++) {
          this.getChildDevice(data.children[i], this.toBeRemove)
        }
      } else {
        this.toBeRemove.push(data.title)
      }
    },
    processNodeArray(deviceImei, selected) {
      if (deviceImei) {
        let d = this.queryDevice(this.deviceList, deviceImei)
        let j = this.queryDevice(this.selectedDevice, deviceImei)
        if (selected) {
          if (j !== undefined) {
            return
          }
          this.selectedDevice.push(this.deviceList[d])
        } else {
          if (j !== undefined) {
            this.selectedDevice.splice(j, 1)
          }
        }
      }
    },
    queryDevice(list, deviceImei) {
      if (list.length !== 0) {
        for (let i = 0; i < list.length; i++) {
          if (deviceImei === list[i].deviceImei) {
            return i
          }
        }
      }
    },
    getLifeguardList() {
      listLifeguard().then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.lifeguardList = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    listAllUser() {
      listAllGpsUser().then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.gpsUserList = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    listAllDevice() { // 获取该账号下的所有设备
      const _this = this
      getAllDeviceByCustomer().then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return _this.$message.error(res.data.msg)
        }
        res.data.data.all.deviceList.forEach(item => {
          _this.deviceList.push(item)
        })
        if (_this.deviceList.length === 0) {
          return
        }
        for (let i = 0; i < _this.deviceList.length; i++) {
          if (_this.deviceList[i].lastLatitude !== null && _this.deviceList[i].lastLongitude !== null) {
            _this.center.lat = _this.deviceList[i].lastLatitude
            _this.center.lng = _this.deviceList[i].lastLongitude
            break
          }
        }
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },

    async listAllDealers() {
      const userId = sessionStorage.getItem('userId') || 0 // 当前帐号ID
      if (userId === 0) return
      const _this = this
      await getAllDeviceByCustomer().then(res => {
        if (res.data.code === 0) {
         
          // alert(res)
          // alert(res.data)
          // alert( res.data.data)
          // alert( res.data.data.all)
          // alert( res.data.data.all.deviceList)
          let node
          _this.allMenuList = []
          _this.onlineMenuList = []
          _this.offlineMenuList = []
          _this.deviceMap = new Map
          _this.trackMap = new Map
          _this.deviceList = []
          _this.queryDeviceList = []
          _this.selectedDevices = []
         // 校验不为空  res.data.data.all.deviceList
         if (res.data.data && res.data.data.all && res.data.data.all.deviceList != null ) {
            res.data.data.all.deviceList.forEach(element => {   // 遍历所有设备对象 
              node = {
                title: element.deviceImei,
                key: element.deviceId,
                nodeId: element.deviceId,
                depth: 1,
                type: 1,
                deviceImei: element.deviceImei,
                deviceVol: element.lastDeviceVol,
                deviceOnline: element.onlineStatus,
                children: []    // []
              }
              // _this.allMenuList.push(node)
              if (element.onlineStatus) {
                // _this.onlineMenuList.push(node)
              } else {
                // _this.offlineMenuList.push(node)
              }
              _this.deviceMap.set(element.deviceImei, '1')
              _this.trackMap.set(element.deviceImei, { tracks: [] })
              _this.deviceList.push(element)
              _this.selectedDevices.push(element.deviceImei)
              _this.queryDeviceList.push(element.deviceImei)
              // 这里
            })
         }else{ //没哟数据

            return;
          // res.data.data.all.childList.forEach(element => {   // 遍历所有设备对象 
          //     node = {
          //       title: element.deviceImei,
          //       key: element.deviceId,
          //       nodeId: element.deviceId,
          //       depth: 1,
          //       type: 1,
          //       deviceImei: element.deviceImei,
          //       deviceVol: element.lastDeviceVol,
          //       deviceOnline: element.onlineStatus,
          //       children: []    // []
          //     }
          //     // _this.allMenuList.push(node)
          //     if (element.onlineStatus) {
          //       // _this.onlineMenuList.push(node)
          //     } else {
          //       // _this.offlineMenuList.push(node)
          //     }
          //     _this.deviceMap.set(element.deviceImei, '1')
          //     _this.trackMap.set(element.deviceImei, { tracks: [] })
          //     _this.deviceList.push(element)
          //     _this.selectedDevices.push(element.deviceImei)
          //     _this.queryDeviceList.push(element.deviceImei)
          //     // 这里
          //   })
         }
        
        // alert("all", res.data.data.all)
        //  alert( "在线",res.data.data.online)
        //   alert( "lix",res.data.data.offline)
          _this.allMenuList = _this.convertToTree(res.data.data.all)
          _this.onlineMenuList = _this.convertToTree(res.data.data.online)
          _this.offlineMenuList= _this.convertToTree(res.data.data.offline)
          // this.recursion(tempArray, node, offlineNode, onlineNode)
          /*_this.$nextTick(() => {
            _this.$refs.mTree.setCheckedKeys(['0'])
          })*/
        }
      })
    },
    getDeviceConfigurationByImei(imei) {
      getDeviceConfiguration(imei).then(res => {
        if (res.data.code === 0) {
          if (res.data.data && res.data.data[0] && res.data.data[0][0]) {
            this.configurationData = res.data.data[0][0]
          }
        }
      })
    },
    // TODO 每次倒计时结束会 调用一次此方法
    async listRescue() {
      const self = this
      await listIncompleteRescue().then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code === 0) {
          // // 是报警的设备？ 没有报警的设备时会报错 
          // self.rescueList = res.data.data
          // // 弹窗 这里需要修改
          // if (self.rescueList) {
          //   self.rescueForm = self.rescueList[0]
          //   self.rescueFormShow = true
          // } else {  // 没有报警的设备数据 
          //   self.rescueFormShow = false
          // }

            //  TODO 优化代码：
             // 弹窗 接收响应数据
          if (res && res.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
              // 数据有效且不为空数组
              self.rescueList = res.data.data;
              self.rescueForm = self.rescueList[0]; // 第一个 赋值给表单
              self.rescueFormShow = true;
          } else {
              // 数据无效或为空数组  隐藏弹窗
              self.rescueFormShow = false;
              // return;
              // self.rescueList = []; // 可选，将rescueList设置为空数组以保持数据一致性
              // self.rescueForm = null; // 可选，清除已选中的表单数据 
              
          }

        } else {
          return self.$message.error('报错啦：' + res.data.msg)
        }
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    async getAllUnReadAlarm() {
      const self = this
      await listUnReadDeviceAlarm().then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code === 0) {
          self.deviceAlarmList = res.data.data
          /*if (self.deviceAlarmList && self.deviceAlarmList.length > 0) {
            setTimeout(function (){
              self.playAudio()
            },500)
          }*/
          return
        }
        self.$message.error('报错啦：' + res.data.msg)
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    collapse() {
      this.hasCollapse = !this.hasCollapse
    },
    handleCurrentChange(val, oldRow) {
      openInfoWindowByDeviceImei(this.mapInstance, val.deviceImei)
    },
    handleCurrentUser(val) {
      this.selectedUser = val
      return this.$message.info(this.selectedUser.userName)
    },
    deviceTypeFormatter(row, column) {
      if (row.deviceType === 1) {
        return 'Positioner'
      } else {
        return 'Watch'
      }
    },
    motionStatusFormatter(row, column) {
      if (row.lastMotionStatus === 1) {
        return 'motion'
      } else if (row.lastMotionStatus === 0) {
        return 'static'
      } else {
        return ''
      }
    },
    alarmTypeFormatter(row, column) {
      let alarmType = row.alarmType
      if (objIsNull(alarmType)) {
        return ''
      }
      for (let i = 0; i < this.alarmTypeDic.length; i++) {
        if (parseInt(this.alarmTypeDic[i].codeValue) === alarmType) {
          return this.alarmTypeDic[i].codeDesc
        }
      }
      return ''
    },
    getAlarmTypeDic() {
      listCodeByClass('ALARM_TYPE').then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.alarmTypeDic = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    setAlarmReadFun(alarmId) {
      setAlarmRead(alarmId).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.getAllUnReadAlarm()
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    locationTypeFormatter(row, column) {
      if (row.lastLocationType === 1) {
        return 'WIFI'
      } else if (row.lastLocationType === 0) {
        return 'GPS'
      } else {
        return 'Base Station'
      }
    },
    realTimeTrack(deviceImei) {
      closeCurrentInfoWindow(this.mapInstance, deviceImei)
      let routeData = this.$router.resolve({
        path: '/device/tracking'
      })
      window.sessionStorage.setItem('trackingDeviceImei', deviceImei)
      window.open(routeData.href, '')
    },
    handleAllSelect(key, keyPath) {
      if (key === 'historical') {
        return this.historicalTrack(this.allMenuSelectedDeviceImei)
      }
      if (key === 'circularFence') {
        return this.openCircularFence(this.allMenuSelectedDeviceImei)
      }
      if (key === 'polygonalFence') {
        return this.openPolygonalFence(this.allMenuSelectedDeviceImei)
      }
      if (key === 'sendCommand') {
        return this.openSendCommandDiag(this.allMenuSelectedDeviceImei)
      }
      if (key === 'config') {
        return this.openConfigDialog(this.allMenuSelectedDeviceImei)
      }
    },
    handleOnlineSelect(key, keyPath) {
      if (key === 'historical') {
        return this.historicalTrack(this.onlineMenuSelectedDeviceImei)
      }
      if (key === 'circularFence') {
        return this.openCircularFence(this.onlineMenuSelectedDeviceImei)
      }
      if (key === 'polygonalFence') {
        return this.openPolygonalFence(this.onlineMenuSelectedDeviceImei)
      }
      if (key === 'sendCommand') {
        return this.openSendCommandDiag(this.onlineMenuSelectedDeviceImei)
      }
      if (key === 'config') {
        return this.openConfigDialog(this.allMenuSelectedDeviceImei)
      }
    },
    handleOfflineSelect(key, keyPath) {
      if (key === 'historical') {
        return this.historicalTrack(this.offlineMenuSelectedDeviceImei)
      }
      if (key === 'circularFence') {
        return this.openCircularFence(this.offlineMenuSelectedDeviceImei)
      }
      if (key === 'polygonalFence') {
        return this.openPolygonalFence(this.offlineMenuSelectedDeviceImei)
      }
      if (key === 'sendCommand') {
        return this.openSendCommandDiag(this.offlineMenuSelectedDeviceImei)
      }
      if (key === 'config') {
        return this.openConfigDialog(this.allMenuSelectedDeviceImei)
      }
    },
    historicalTrack(deviceImei) {
      closeCurrentInfoWindow(this.mapInstance, deviceImei)
      let routeData = this.$router.resolve({
        path: '/device/historicalTrack'
      })
      window.sessionStorage.setItem('historicalTrackDeviceImei', deviceImei)
      window.open(routeData.href, '')
    },
    openCircularFence(deviceImei) {
      closeCurrentInfoWindow(this.mapInstance, deviceImei)
      let routeData = this.$router.resolve({
        path: '/device/circularFence'
      })
      window.sessionStorage.setItem('circularFenceDeviceImei', deviceImei)
      window.open(routeData.href, '')
    },
    openPolygonalFence(deviceImei) {
      closeCurrentInfoWindow(this.mapInstance, deviceImei)
      let routeData = this.$router.resolve({
        path: '/device/polygonalFence'
      })
      window.sessionStorage.setItem('polygonalFenceDeviceImei', deviceImei)
      window.open(routeData.href, '')
    },
    getDeviceInfo(deviceImei) {
      this.getDeviceByDeviceImei(deviceImei)
      this.infoDialogVisible = true
    },
    openSendCommandDiag(deviceImei) {
      this.getMovementAlertDic()
      this.getAuthorizedPhoneTypeDic()
      this.getSpeedLimitDic()
      this.currentDeviceImei = deviceImei
      const self = this
      setTimeout(function () {
        self.commandDialogVisible = true
      }, 300)
    },
    transferDevice(deviceImei) {  // TODO 转移设备
      this.addDialogVisible = true;
      this.deviceIMIE = deviceImei
      // alert("转移设备"+deviceImei)
    },
    handleRescueFormClose(done) {
      const self = this
      self.$confirm('确认关闭警报对话框？')
        .then(_ => {
          self.rescueFormShow = false
        })
        .catch(_ => {
          // 如果用户选择不关闭，则不调用done方法
          self.rescueFormShow = true
        });
    },
    sendCommand(cmdValue) {
      /*for (let i = 0; i < this.deviceList.length; i++) {
        if (this.deviceList[i].deviceImei === this.currentDeviceImei) {
          if (!this.deviceList[i].onlineStatus){
            return this.$message.error('设备不在线！')
          }
          break
        }
      }*/
      const req = {
        deviceImei: this.currentDeviceImei,
        cmdValue: cmdValue,
        content: this.commandContent
      }
      const self = this
      sendRemoteControl(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.success('Send Command Success!')
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    modifyConfiguration(deviceImei) {
      window.sessionStorage.setItem('deviceImei', deviceImei)
      this.showConfigDialog = true
      this.currentDeviceImei = deviceImei
      this.configurationData = {}
      this.getDeviceConfigurationByImei(deviceImei)
      // window.open(this.$router.resolve({
      //   path: 'device/configurationInfo'
      // }).href, '')
    },
    flightTraining(deviceImei) {
      sessionStorage.setItem('deviceImei', deviceImei)
      window.open(this.$router.resolve({ path: 'device/flightTraining' }).href, '')
    },
    setTimeIntervalForTrackingFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        interval: this.commandForm.setTimeInterval
      }
      setTimeIntervalForTracking(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        return this.$message.info('Send Command Success!')
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    setTimeZoneFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        timeZoneValue: this.commandForm.timeZoneValue
      }
      const self = this
      setTimeZone(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.info(self.$t('welcome.msg.sendCmdSuccess'))
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    setAngleForTrackingFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        angle: this.commandForm.angle
      }
      const self = this
      setAngleForTracking(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.info(self.$t('welcome.msg.sendCmdSuccess'))
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    setOdometerIntervalFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        distance: this.commandForm.distance
      }
      const self = this
      setOdometerInterval(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.info(self.$t('welcome.msg.sendCmdSuccess'))
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    setTelePhoneForWiretappingFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        phoneNumber: this.commandForm.phoneNumber
      }
      const self = this
      setTelePhoneForWiretapping(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.info(self.$t('welcome.msg.sendCmdSuccess'))
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    setSpeedLimitFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        speed: this.commandForm.speed
      }
      const self = this
      setSpeedLimit(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.info(self.$t('welcome.msg.sendCmdSuccess'))
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    setMovementAlertFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        meters: this.commandForm.meters
      }
      const self = this
      setMovementAlert(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.info(self.$t('welcome.msg.sendCmdSuccess'))
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    setAuthorizedPhoneNumberFunc() {
      const req = {
        deviceImei: this.currentDeviceImei,
        buttonNumber: this.commandForm.buttonNumber,
        phoneNumberForReceiveSms: this.commandForm.phoneNumberForReceiveSms,
        phoneNumberForReceiveCall: this.commandForm.phoneNumberForReceiveCall
      }
      const self = this
      setAuthorizedPhoneNumber(req).then(res => {
        if (isNotLogin(res)) {
          return router.push({ path: '/login' })
        }
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        return self.$message.info(self.$t('welcome.msg.sendCmdSuccess'))
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    handleChange(val) {
    },
    handleNodeClick(data) {

    },
    handleClick(tab, event) {
      this.tabIndex = tab.index
    },
    hideUserList() {
      this.showUserList = !this.showUserList
    },
    hideDeviceInfoList() {
      this.showDeviceInfoList = !this.showDeviceInfoList
    },
    commandDialogClosed() {
      this.currentDeviceImei = ''
      this.$refs.commandForm.resetFields()
    },
    infoDialogClosed() {
      this.infoForm = {
        deviceImei: '',
        deviceName: '',
        deviceType: undefined,
        bindMobile: '',
        version: '',
        deviceShortNumber: '',
        deviceFamilyNumber: '',
        deviceRemark: '',
        lastLongitude: undefined,
        lastLatitude: undefined,
        lastLocationTime: undefined,
        lastLocationType: undefined,
        lastSpeed: undefined,
        lastMotionStatus: undefined,
        lastDeviceVol: '',
        lastDeviceSms: '',
        heading: undefined,
        odometer: undefined,
        onlineStatus: undefined
      }
      this.$refs.infoForm.resetFields()
    },
    convertDateTimeToString(date) {
      return moment(date).format('yyyy/MM/DD HH:mm:ss')
    },
    deviceInfoListDragStart(e) {
      // console.log('start:' + e.clientX + '&&' + e.clientY)
      this.startClientX = e.clientX
      this.startClientY = e.clientY
    },
    deviceInfoListDragEnd(e) {
      // console.log('end:' + e.clientX + '&&' + e.clientY)
      const target = document.getElementsByClassName('deviceInfoList')[0]
      const parent = document.getElementsByClassName('el-main')[0]
      // console.log(parent.offsetHeight)
      let x = e.clientX - this.startClientX
      let y = e.clientY - this.startClientY
      // console.log('x: ' + x + '&&' + 'y:' + y)
      this.elRight -= x
      this.elBottom -= y
      const heightThreshold = parent.offsetHeight - target.offsetHeight
      const widthThreshold = parent.offsetWidth - target.offsetWidth
      if (this.elBottom >= heightThreshold) { // 对Y轴偏移量进行限制,防止完全移出屏幕
        this.elBottom = heightThreshold
      } else if (this.elBottom <= 0) {
        this.elBottom = 0
      }
      if (this.elRight >= widthThreshold) { // 对X轴偏移量进行限制,防止完全移出屏幕
        this.elRight = widthThreshold
      } else if (this.elRight <= 0) {
        this.elRight = 0
      }
      target.style.right = this.elRight + 'px'
      target.style.bottom = this.elBottom + 'px'
    },
    toSoldDeviceManage(data) {
      // this.$router.push({ path: 'device/soldDevice' })
      
      sessionStorage.setItem('dealerId', data.nodeId)
      sessionStorage.setItem('dealerName', data.title)
      window.open(this.$router.resolve({ path: 'device/soldDevice' }).href, '')
    },
    getConfValueByKey(key) {
      if (!this.configurationData || !this.configurationData[key]) return ''
      // console.log('configuration[' + key + ']: ' + this.configurationData[key])
      switch (key) {
        case 'standbyDatetime': // 开始待机时间
          return this.configurationData[key] ? moment(this.configurationData[key]).format('yyyy-MM-DD HH:mm:ss') : ''
        case 'rsut': // 设定预约开机时间
          return this.configurationData[key] ? moment(this.configurationData[key]).format('yyyy-MM-DDTHH:mm') : ''
        case 'cst': // 配置数据修改时间
          return this.configurationData[key] ? moment(this.configurationData[key]).format('yyyy-MM-DD HH:mm:ss') : ''
        case 'rgli': // 定位频率
        case 'rdui': // 上传频率
          return this.configurationData[key]
        case 'lpl': // 低电量门限
          return this.configurationData[key]
        case 'lpgli': // 低电量模式定位频率
        case 'lpdui': // 低电量模式上传频率
          return this.configurationData[key]
        case 'nmst': // 第二段开始时间
        case 'nmet': // 第二段结束时间
          // console.log(moment(this.configurationData[key]).format('HH:mm'))
          return this.configurationData[key] ? moment(this.configurationData[key] + 8 * 60 * 60 * 1000).utc(0).format('HH:mm') : ''
        case 'ngli': // 第二段定位频率
        case 'ndui': // 第二段数据上传频率
        case 'cgli': // 第三段定位频率
        case 'cdui': // 第三段数据上传频率
          return this.configurationData[key]
        case 'rdut': // 数据上传启动时间
          return this.configurationData[key] ? moment(this.configurationData[key]).format('yyyy-MM-DD') : ''
        case 'gddt': // 开始下载星历时间
          return this.configurationData[key] ? moment(this.configurationData[key]).format('yyyy-MM-DD HH:mm:ss') : ''
        case 'rsud': // 比赛延迟开始时间
          return this.configurationData[key] / 60 || 0
      }
    },
    timeInputHandler(e) {
      switch (e.target.name) {
        case 'nmst':
        case 'nmet': {
          const timeArray = e.target.value.split(':')
          let timeStamp = 0
          for (let i = 0; i < timeArray.length; i++) {
            const item = parseInt(timeArray[i])
            if (i === 0) {
              timeStamp += item * 1000 * 60 * 60
            } else {
              timeStamp += item * 1000 * 60
            }
          }
          this.configurationData[e.target.name] = timeStamp - 8 * 60 * 60 * 1000
        }
          break
        case 'rdut':
        case 'rsut':
          if (e.target.value) {
            const timeStamp = new Date(e.target.value).getTime()
            this.configurationData[e.target.name] = timeStamp
          } else {
            this.configurationData[e.target.name] = undefined
          }
          break
      }
    },
    inputDelayTime(e) {
      if (!this.configurationData) return
      this.configurationData.rsud = e.target.value * 60
    },
    clickConfirmUpdateConfigurationButton(imei, configuration) {
      updateDeviceConfiguration(imei, configuration).then(res => {
        if (res.data.code === 0) {
          this.showConfigDialog = false
          this.$message.success(this.$t('common.updateSuccess'))
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getSpecifiedDeviceType(type) {
      return getDeviceTypeStr(this, type)
    },
    getSpecifiedLocationType(type) {
      return getLocationTypeStr(this, type)
    },
    onAllSelect() {
      const self = this
      this.$nextTick(() => {
        if (self.tabIndex === '0') {
          self.$refs.mTree.setCheckedKeys(['0'], false)
        } else if (self.tabIndex === '1') {
          self.$refs.mAvailableTree.setCheckedKeys(['0'], false)
        } else if (self.tabIndex === '2') {
          self.$refs.mLostTree.setCheckedKeys(['0'], false)
        } else if (self.tabIndex === '0') {
          self.$refs.mTree.setCheckedKeys(['0'], false)
        }
      })
    },
    onNoSelect() {
      const self = this
      this.$nextTick(() => {
        if (self.tabIndex === '0') {
          self.$refs.mTree.setCheckedNodes([])
        } else if (self.tabIndex === '1') {
          self.$refs.mAvailableTree.setCheckedNodes([])
        } else if (self.tabIndex === '2') {
          self.$refs.mLostTree.setCheckedNodes([])
        } else {
          self.$refs.mTree.setCheckedNodes([])
        }
      })
    },
    onConfirm() {
      this.queryDeviceList.splice(0, this.queryDeviceList.length)
      let nodes
      if (this.tabIndex === '0') {
        nodes = this.$refs.mTree.getCheckedNodes()
      } else if (self.tabIndex === '1') {
        nodes = this.$refs.mAvailableTree.getCheckedNodes()
      } else if (self.tabIndex === '2') {
        nodes = this.$refs.mLostTree.getCheckedNodes()
      } else {
        nodes = this.$refs.mTree.getCheckedNodes()
      }
      nodes.forEach(item => {
        if (item.deviceImei) {
          this.queryDeviceList.push(item.deviceImei)
        }
      })
      for (let [key, value] of this.deviceMap) {
        let isQuery = false
        for (let i = 0; i < this.queryDeviceList.length; i++) {
          let deviceImei = this.queryDeviceList[i]
          if (deviceImei === key) {
            if (value !== '1') {
              this.showDeviceTrack(key)
            }
            this.deviceMap.set(key, '1')
            isQuery = true
            break
          }
        }
        if (!isQuery) {
          if (value === '1') {
            this.hideDeviceTrack(key)
          }
          this.deviceMap.set(key, '0')
        }
      }
      this.startSearchTrackLog()
    },
    getRandomColor() {
      var str = '#';
      //一个十六进制的值的数组
      var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
      for (var i = 0; i < 6; i++) {
        var num = parseInt(Math.random() * 16); //随机产生0-15之间的一个数
        str += arr[num]; //产生的每个随机数都是一个索引,根据索引找到数组中对应的值,拼接到一起
      }
      return str;
    },
    addDeviceMarker(type, model) {
      let marker = null
      if (type === 2) {
        marker = makeTrackMarker(this.mapInstance, model, 'start')
      } else if (type === 1) {
        marker = makeTrackMarker(this.mapInstance, model, 'end')
      } else {
        if (model.supplement === 1) {
          marker = makeTrackMarker(this.mapInstance, model, 'supplement')
        } else {
          marker = makeTrackMarker(this.mapInstance, model, 'subordinate')
        }
      }
      marker.deviceObj = model
      return marker
    },
    addPolyline(model, marker, lineList, deviceImei) {
      if (model && lineList.length > 0) {
        lineList.push(model)
      } else if (model) {
        lineList.push(model)
      } else {
        let polylineList = this.polylineMap.get(deviceImei)
        let polylineColor = this.colorMap.get(deviceImei)
        if (!polylineList) {
          polylineList = []
          this.polylineMap.set(deviceImei, polylineList)
        }
        if (!polylineColor) {
          polylineColor = this.getRandomColor()
          this.colorMap.set(deviceImei, polylineColor)
        }
        polylineList.push(makeColorPath(this.mapInstance, lineList, polylineColor))
      }
    },
    addDeviceTrackMarker(deviceImei, trackList) {
      if (trackList && trackList.length) {
        // 最后一条定位记录
        let lastTrackModel = trackList[trackList.length - 1]
        let deviceModel = null
        let markerList = this.deviceTrackMap.get(deviceImei)
        let lineList = []
        if (markerList && markerList.length) {
          let marker = markerList[markerList.length - 1]
          let trackModel = marker.deviceObj
          if (!trackModel.logId) {
            markerList.splice(0, markerList.length)
            marker = null
          }
          if (marker) {
            switch (this.mapInstance.mapType) {
              case "baidu":
                this.mapInstance.map.removeOverlay(marker)
                break;
              case "google":
                marker.setMap(null)
                break;
              default:
            }
            markerList.splice(markerList.length - 1, 1)
            let addMarker
            if (markerList.length) {
              addMarker = this.addDeviceMarker(0, trackModel)
            } else {
              addMarker = this.addDeviceMarker(2, trackModel)
            }
            markerList.push(addMarker)
            this.addPolyline(trackModel, addMarker, lineList, deviceImei)
          }
        } else if (!markerList) {
          markerList = []
          this.deviceTrackMap.set(deviceImei, markerList)
        }
        for (let index = 0; index < trackList.length - 1; index++) {
          let model = trackList[index]
          let addMarker
          if (markerList.length + index === 0) {
            addMarker = this.addDeviceMarker(2, model)
          } else {
            addMarker = this.addDeviceMarker(0, model)
          }
          markerList.push(addMarker)
          this.addPolyline(model, addMarker, lineList, deviceImei)
        }
        let lastMarker = this.addDeviceMarker(markerList.length === 0 ? 2 : 1, lastTrackModel)
        markerList.push(lastMarker)
        this.addPolyline(lastTrackModel, lastMarker, lineList, deviceImei)
        this.addPolyline(null, null, lineList, deviceImei)
        trackList.splice(0, trackList.length)
        let point = {
          lat: lastTrackModel.lat,
          lng: lastTrackModel.lng
        }
        moveToCenter(this.mapInstance, point)
      }
    },
    showDeviceTrack(deviceImei) {
      let markerList = this.deviceTrackMap.get(deviceImei)
      let polylineList = this.polylineMap.get(deviceImei)
      if (markerList) {
        markerList.forEach(item => {
          switch (this.mapInstance.mapType) {
            case "baidu":
              this.mapInstance.map.addOverlay(item)
              break;
            case "google":
              item.setMap(this.mapInstance.map)
              break;
            default:
          }
        })
      }
      if (polylineList) {
        polylineList.forEach(item => {
          switch (this.mapInstance.mapType) {
            case "baidu":
              this.mapInstance.map.addOverlay(item)
              break;
            case "google":
              item.setMap(this.mapInstance.map)
              break;
            default:
          }
        })
      }
    },
    hideDeviceTrack(deviceImei) {
      let markerList = this.deviceTrackMap.get(deviceImei)
      let polylineList = this.polylineMap.get(deviceImei)
      if (markerList) {
        markerList.forEach(item => {
          switch (this.mapInstance.mapType) {
            case "baidu":
              this.mapInstance.map.removeOverlay(item)
              break;
            case "google":
              item.setMap(null)
              break;
            default:
          }
        })
      }
      if (polylineList) {
        polylineList.forEach(item => {
          switch (this.mapInstance.mapType) {
            case "baidu":
              this.mapInstance.map.removeOverlay(item)
              break;
            case "google":
              item.setMap(null)
              break;
            default:
          }
        })
      }
    },
    // 不要了
    startSearchTrackLog() {
      if (this.queryDeviceList.length) {
        let startTime = moment(new Date()).format('yyyy-MM-DD 00:00:00')
        let endTime = moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
        let jsonArray = []
        let queryCount = 0
        for (let i = this.queryDeviceList.length - 1; i >= 0; i--) {
          let deviceImei = this.queryDeviceList[i]
          if (this.deviceMap.has(deviceImei) && '1' === this.deviceMap.get(deviceImei)) {
            let trackList = this.trackListMap.get(deviceImei)
            let jsonObject = {}
            jsonObject['deviceImei'] = deviceImei
            jsonObject['startTime'] = startTime
            jsonObject['endTime'] = endTime
            jsonObject['requestRows'] = REQUEST_ROWS

            let model = null
            if (trackList && trackList.length) {
              model = trackList[trackList.length - 1]
            } else {
              let markerList = this.deviceTrackMap.get(deviceImei)
              if (markerList && markerList.length) {
                model = markerList[markerList.length - 1].deviceObj
              }
            }
            if (model && model['logId']) {
              jsonObject['nextId'] = model['logId']
            } else {
              jsonObject['nextId'] = 0
            }
            jsonArray.push(jsonObject)
            if (queryCount >= 9) {
              break
            }
            queryCount++
          } else {
            this.queryDeviceList.splice(i, 1)
          }
        }
        if (jsonArray.length) {
          this.onMultipleDeviceTraceLog(jsonArray)
          return
        } else if (this.queryDeviceList.length) {
          this.startSearchTrackLog()
          return
        }
      }
      for (let [key, value] of this.trackListMap) {
        this.addDeviceTrackMarker(key, value)
      }
      this.trackListMap.clear()
    },
    // 不要了
    onMultipleDeviceTraceLog(jsonArray) {
      getMultipleDeviceTraceLog(jsonArray).then(res => {
        if (res.data.code === 0) {
          let dataList = res.data.data
          if (dataList && dataList.length) {
            let numMap = new Map()
            let isHasTrack = false
            dataList.forEach(element => {
              if (element && element.list && element.list.length) {
                isHasTrack = true
                element.list.forEach(item => {
                  let deviceImei = item.deviceImei
                  let trackList = this.trackListMap.get(deviceImei)
                  if (!trackList) {
                    trackList = []
                    this.trackListMap.set(deviceImei, trackList)
                  }
                  let num = numMap.get(deviceImei)
                  if (num) {
                    num += 1
                  } else {
                    num = 1
                  }
                  numMap.set(deviceImei, num)
                  if (Math.round(item.lat) !== 0 && Math.round(item.lng) !== 0) {
                    trackList.push(item)
                  }
                })
              }
            })
            let queryCount = 0
            for (let i = this.queryDeviceList.length - 1; i >= 0; i--) {
              let deviceImei = this.queryDeviceList[i]
              if (deviceImei && deviceImei.length) {
                let num = numMap.get(deviceImei)
                if (!num || num === 0 || num % REQUEST_ROWS !== 0) {
                  this.queryDeviceList.splice(i, 1)
                  this.addDeviceTrackMarker(deviceImei, this.trackListMap.get(deviceImei))
                  this.trackListMap.delete(deviceImei, null)
                  // this.trackList.remove(deviceImei)
                }
              } else {
                this.queryDeviceList.splice(i, 1)
              }
              if (queryCount >= 9) {
                break
              }
              queryCount++
            }
            if (this.queryDeviceList.length) {
              this.startSearchTrackLog()
              return
            }
          }
        }
        this.queryDeviceList.splice(0, this.queryDeviceList.length)
        this.startSearchTrackLog()
      }).catch(e => {
        this.queryDeviceList.splice(0, this.queryDeviceList.length)
        this.startSearchTrackLog()
      })
    },
    playAudio() {
      let self = this
      self.$refs.sosAudio.currentTime = 0
      self.$refs.sosAudio.play()
      self.muted = false
    },
    playEnd() {
      this.muted = true
    }
  }
}
</script>

<style lang="less" scoped>
.alarmTable {
  margin: 0;
  border-radius: 10px;
  border: 1px solid #00A2E9;

  /deep/ td {
    padding: 0;
    border: 0;
  }
}

.lifeguardTable {
  margin: 0;

  /deep/ td {
    padding: 0;
    border: 0;
  }
}

.deviceInfoList {
  margin: 0 auto;
  position: absolute;
  z-index: 11;
}

.closeDeviceInfoListButton {
  height: 20px;
  width: 20px;
  position: absolute;
  right: 0;
  top: 0;
  line-height: 18px;
  font-size: 16px;
  border-radius: 50%;
  border: 1px solid white;
  background-color: #00A2E9;
  text-align: center;
  z-index: 10;
}

.listInfoTipBtn {
  cursor: pointer;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  color: white;
  position: absolute;
  background-color: rgb(0, 162, 233);
  text-align: center;
  z-index: 8;
  border-radius: 5px;
  right: 20px;
  padding: 0 10px;
  bottom: 10px;
}

/*.listTipBtn {*/
/*  width: 22px;*/
/*  cursor: pointer;*/
/*  font-size: 14px;*/
/*  height: 90px;*/
/*  font-weight: bold;*/
/*  color: white;*/
/*  position: absolute;*/
/*  background-color: rgb(0, 162, 233);*/
/*  text-align: center;*/
/*  border-radius: 5px;*/
/*  margin-top: 150px;*/
/*  z-index: 8;*/
/*  right: 10px;*/
/*  bottom: 10%;*/
/*}*/

.listTipBtn {
  cursor: pointer;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  color: white;
  position: absolute;
  background-color: rgb(0, 162, 233);
  text-align: center;
  z-index: 8;
  border-radius: 5px;
  left: 10px;
  padding: 0 10px;
  bottom: 50px;
}

.userList {
  position: absolute;
  /*bottom: 5%;*/
  top: 15%;
  right: 5px;
  width: 150px;
  z-index: 9;
}

/*.lifeguardList {
  position: absolute;
  !*bottom: 5%;*!
  top: 10%;
  right: 5px;
  width: 150px;
  z-index: 9;
}*/

.itemBtm button {
  margin-left: 10px;
}

.mapContainer.collapseList {
  width: 100%;
}

.mapContainer {
  height: 100%;
  width: calc(100% - 400px);
  float: left;
}

/*.baiduMap {*/
/*  height: 100%;*/
/*  width: calc(100% - 310px);*/
/*  float: left;*/
/*}*/

.baidu-map {
  width: 100%;
  height: 100%;
}

.collapseImg.collapseList {
  left: 0;
}

.collapseImg {
  position: absolute;
  top: 50%;
  left: 367px; // 260px
  border: 1px solid #ddd;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  z-index: 10;
}

.collapseImg:hover {
  border: 1px solid orange;
}

.el-collapse-item__content {
  padding-bottom: 10px;
}

.groupItem.active {
  background-color: #fff5ec;
  border: 1px #ffe3c7 solid;
}

.itemBtm .el-menu.el-menu--horizontal {
  text-align: right;
  overflow: hidden;
}

.itemBtm button .el-menu.el-menu--horizontal {
  font-size: 9px;
  float: right;
}

.itemBtm .el-menu.el-menu--horizontal {
  float: right;
}

.el-menu.el-menu--horizontal {
  display: inline-block;
  border: 0;
  background-color: transparent;
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: transparent;
}

.el-menu--horizontal>.el-submenu .el-submenu__title {
  height: unset !important;
  line-height: unset !important;
  font-size: 9px !important;
  padding: 0px 0 !important;
  margin-left: 2px !important;
  color: #00A2E9 !important;
}

.itemTop.on {
  color: #00CC33;
}

.itemTop {
  overflow: hidden;
}

.groupItem {
  overflow: hidden;
  cursor: pointer;
}

.groupItem .codeName {
  width: 130px;
}

.itemTop>div {
  float: left;
}

.el-tabs__header {
  margin: 0;
}

.el-tabs__nav-wrap {
  background-color: #f6f7fb;
  text-align: center;
  padding-left: 10px;
}

.addGroupWarp {
  padding: 8px 0;
}

.btnGroup button {
  padding: 8px 8px;
}

.btnGroup {
  text-align: right;
}

.cancel {
  margin-left: 2px;
}

.el-input__prefix,
.el-input__suffix {
  top: -6px;
}

.el-input__inner {
  height: 28px;
}

.searchInput {
  width: 94%;
  margin-top: 4px;
}

.location {
  height: 100%;
  position: relative;
  overflow: hidden;
}
.custom-tree-node {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.deviceList {
  width: 400px;
  height: 100% !important;
  float: left;
  overflow-x: scroll;
  overflow-y: scroll;
  background-color: #FFFFFF;
  border-radius: 10px 0 0 10px;
 
  //树形菜单样式
  .treeWrap {
    /* 设置外层div的高度和宽度 */
    // height: 160px;
    width: 300px;
    /* 使得超出部分可以滚动 */
    overflow-y: auto;
    /* 垂直滚动 */
    overflow-x: hidden;
    /* 如果不需要水平滚动，可以设置为hidden */
    /* 可选：添加一些内边距，以便更好地查看内容 */
    padding: 3px;
    /* 可选：为标题添加一些上边距 */
    margin-bottom: 3px;
    /* 确保标题和树形控件之间有足够的空间 */
    border: 1px solid #ccc;
    /* 可选：添加边框以区分边界 */
  }
}

.deviceList.collapseList {
  display: none;
}

.title {
  padding: 8px 10px;
  font-size: 15px;
  overflow: hidden;
}

.addGroup {
  float: right;
}

.timeClass {
  font-weight: bold;
  color: black;
  background: #dddddd;
  position: absolute;
  text-align: center;
  z-index: 8;
  border-radius: 5px;
  left: 33%;
  top: 2.5%;
}

.commandFormClass {
  width: 100% !important;
}

.remoteControlCard {
  width: 100%;
}

.el-input {
  // width: 100px !important; //改了
}

.el-select {
  // width: 100px !important;
}

.sendMessage {
  width: 300px !important;
}

.sendBtn {
  background: url('../assets/send-icon-32.png') no-repeat 15px;
  border: none;
  height: 30px;
  width: 60px;
}

.searchImei {
  width: 100% !important;
}

.wideInput {
  width: 150px !important;
}

.operation {
  color: #108cf8;
  margin-left: 10px;
}

.statusOnline {
  border: 1px solid red;
  width: 4px;
  height: 4px;
  background-color: red;
  margin-top: 6px;
  border-radius: 3px;
}

.statusRun {
  border: 1px solid green;
  width: 4px;
  height: 4px;
  background-color: green;
  margin-top: 6px;
  border-radius: 3px;
}

.statusOffline {
  border: 1px solid #fcd820;
  width: 4px;
  height: 4px;
  background-color: #fcd820;
  margin-top: 6px;
  border-radius: 3px;
}

.offlineText {
  color: #fcd820;
  font-size: xx-small;
}

.onlineText {
  color: red;
  font-size: xx-small;
}

.runText {
  color: green;
  font-size: xx-small;
}

.totalText {
  font-size: 15px;
}

.treeIcon {
  height: 16px;
  width: 16px;
}

.itemClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: row nowrap;
}

.tabWrap {
  height: calc(100% - 160px);
 
  .allTree {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /deep/ .el-tabs__content {
    flex: 1;
  }

  .el-tab-pane {
    height: 100%;
  }

  .el-tree {
    height: 90%;
    overflow: auto;
    box-sizing: border-box;
  }

  /deep/ .el-tree-node__children {
    overflow: visible !important;
  }

  // :deep .el-tree-node{
  //   height: 100%;
  //   // 横向滚动条
  //   // el-tree-node__children的样式默认overflow:hidden
  //   // 继承宽度，当宽度超出时隐藏，固不显示横向滚动
  //   .el-tree-node__children{
  //     overflow: visible;
  //   }

  // }
  // :deep .el-tree-node__children{
  //     overflow: visible !important;
  //   }
  //高宽分别对应横竖滚动条的尺寸
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  //定义滚动条轨道 内阴影 圆角
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  //定义滑块 内阴影 圆角
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #9cceff;
  }
}

.sendCmdForm {
  background-color: white !important;
  height: 30% !important;
}

.sendCmdItem {
  background-color: white !important;
}

/deep/ .itemClass {
  padding-right: 8px ;
}

/deep/ .el-dialog {
  border-radius: 20px;
}

/deep/ .el-dialog__header {
  background-color: #00A2E9;
  border-radius: 20px 20px 0 0;
}

/deep/ .el-dialog__header .el-dialog__title {
  color: white;
}

/deep/ .el-dialog__body {
  padding: 10px 20px 20px 20px;
  color: black;
  font-size: 12px;
}

/deep/ .el-dialog__body input {
  width: 140px;    // 改了
  font-size: 12px;
  margin: 1px 0;
}

/deep/ .el-dialog_body span {
  font-size: 12px;
  color: #232423;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.el-form-item-class {
  height: 24px;
  margin: 0;
  background-color: rgb(118, 103, 29);
}

.rescueItem {
  height: 18px;
  // margin: 0;
}
</style>
